import { ModelBaseModel } from '../model-base/model-base.model'

import { CONST } from '../../const/const'
import { IRiderTeamMemberInterface } from './riderTeamMember.interface'

// Constants
const RIDER_TEAM_MEMBER_COLLECTION = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.RIDER_TEAM_MEMBER

export class RiderTeamMemberModel extends ModelBaseModel<IRiderTeamMemberInterface> {
  public v: IRiderTeamMemberInterface['v']
  public id: IRiderTeamMemberInterface['id']

  public eventId: IRiderTeamMemberInterface['eventId']
  public eventName: IRiderTeamMemberInterface['eventName']

  public userId: IRiderTeamMemberInterface['userId']

  public teamMemberId: IRiderTeamMemberInterface['teamMemberId']
  public teamMemberName: IRiderTeamMemberInterface['teamMemberName']
  public teamMemberEmail: IRiderTeamMemberInterface['teamMemberEmail']
  public teamMemberDob: IRiderTeamMemberInterface['teamMemberDob']
  public teamMemberRole: IRiderTeamMemberInterface['teamMemberRole']
  public teamMemberProfilePicture: IRiderTeamMemberInterface['teamMemberProfilePicture']

  public mailLog: IRiderTeamMemberInterface['mailLog']

  public riderId: IRiderTeamMemberInterface['riderId']
  public riderNameNGram: IRiderTeamMemberInterface['riderNameNGram']
  public riderDob: IRiderTeamMemberInterface['riderDob']
  public riderName: IRiderTeamMemberInterface['riderName']
  public riderEmail: IRiderTeamMemberInterface['riderEmail']
  public riderProfilePicture: IRiderTeamMemberInterface['riderProfilePicture']
  public riderCountry: IRiderTeamMemberInterface['riderCountry']

  public registrationDocId: IRiderTeamMemberInterface['registrationDocId']

  public horseId: IRiderTeamMemberInterface['horseId']
  public horseName: IRiderTeamMemberInterface['horseName']
  public horseProfilePicture: IRiderTeamMemberInterface['horseProfilePicture']

  public created: IRiderTeamMemberInterface['created']
  public modified: IRiderTeamMemberInterface['modified']

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @param obj `IRiderTeamMemberInterface`
   */
  public constructor(obj?: IRiderTeamMemberInterface) {
    super()

    this.v = obj?.v ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.V.VALUES.DEFAULT
    this.id = obj?.id ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.ID.VALUES.DEFAULT
    this.eventId = obj?.eventId ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.EVENT_ID.VALUES.DEFAULT
    this.registrationDocId =
      obj?.registrationDocId ??
      RIDER_TEAM_MEMBER_COLLECTION.FIELDS.REGISTRATION_DOC_ID.VALUES.DEFAULT
    this.userId = obj?.userId ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.USER_ID.VALUES.DEFAULT
    this.teamMemberId =
      obj?.teamMemberId ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_ID.VALUES.DEFAULT
    this.teamMemberName =
      obj?.teamMemberName ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_NAME.VALUES.DEFAULT
    this.teamMemberEmail =
      obj?.teamMemberEmail ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_EMAIL.VALUES.DEFAULT
    this.teamMemberDob =
      obj?.teamMemberDob ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_DOB.VALUES.DEFAULT
    this.teamMemberRole =
      obj?.teamMemberRole ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_ROLE.VALUES.DEFAULT
    this.eventName = obj?.eventName ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.EVENT_NAME.VALUES.DEFAULT
    this.riderId = obj?.riderId ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_ID.VALUES.DEFAULT
    this.mailLog = obj?.mailLog ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.MAIL_LOG.VALUES.DEFAULT
    this.riderNameNGram =
      obj?.riderNameNGram ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_NAME_N_GRAM.VALUES.DEFAULT
    this.riderDob = obj?.riderDob ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_DOB.VALUES.DEFAULT
    this.riderName = obj?.riderName ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_NAME.VALUES.DEFAULT
    this.riderEmail =
      obj?.riderEmail ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_EMAIL.VALUES.DEFAULT
    this.riderProfilePicture =
      obj?.riderProfilePicture ??
      RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_PROFILE_PICTURE.VALUES.DEFAULT
    this.riderCountry =
      obj?.riderCountry ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.RIDER_COUNTRY.VALUES.DEFAULT
    this.teamMemberProfilePicture =
      obj?.teamMemberProfilePicture ??
      RIDER_TEAM_MEMBER_COLLECTION.FIELDS.TEAM_MEMBER_PROFILE_PICTURE.VALUES.DEFAULT

    this.horseId = obj?.horseId ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.HORSE_ID.VALUES.DEFAULT
    this.horseName = obj?.horseName ?? RIDER_TEAM_MEMBER_COLLECTION.FIELDS.HORSE_NAME.VALUES.DEFAULT
    this.horseProfilePicture =
      obj?.horseProfilePicture ??
      RIDER_TEAM_MEMBER_COLLECTION.FIELDS.HORSE_PROFILE_PICTURE.VALUES.DEFAULT

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified || null,
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new RiderTeamMemberModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
